module.exports = __webpack_public_path__ + "img/img0104.1927be9c.png";